/* eslint no-param-reassign: "off" */

export default {
  install(Vue) {
    Vue.prototype.$profiler = {
      start(label) {
        if (process.env.NODE_ENV === 'development') console.time(label);
      },
      end(label) {
        if (process.env.NODE_ENV === 'development') console.timeEnd(label);
      },
    };
  }
};
